import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const UserFormDialog = ({ open, onClose, editingUser, formData, setFormData, allBanks, selectedBanks, setSelectedBanks, currentUser, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{editingUser ? 'Edit User' : 'Add New User'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="name">Full Name *</Label>
              <Input id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="username">Username *</Label>
              <Input id="username" value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} required disabled={editingUser !== null} />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="password">Password {editingUser ? '(leave blank to keep current)' : '*'}</Label>
              <Input id="password" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required={!editingUser} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="role">Role *</Label>
              <Select value={formData.role} onValueChange={(value) => setFormData({ ...formData, role: value })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  {currentUser.role === 'Admin' && (
                    <>
                      <SelectItem value="Admin">Admin</SelectItem>
                      <SelectItem value="Sub Admin">Sub Admin</SelectItem>
                    </>
                  )}
                  <SelectItem value="Agent">Agent</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          {formData.role === 'Agent' && (
            <>
              <div className="space-y-2">
                <Label htmlFor="accessLevel">Access Level *</Label>
                <Select value={formData.accessLevel} onValueChange={(value) => { setFormData({ ...formData, accessLevel: value }); if (value === 'all') setSelectedBanks([]); }}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Vendors & Banks</SelectItem>
                    <SelectItem value="specific">Specific Banks Only</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {formData.accessLevel === 'specific' && (
                <div className="space-y-2 p-4 bg-slate-50 rounded-lg border">
                  <Label>Assign Banks ({selectedBanks.length} selected)</Label>
                  <div className="max-h-48 overflow-y-auto space-y-2">
                    {allBanks.map((bank) => (
                      <label key={bank.id} className="flex items-center gap-2 p-2 hover:bg-white rounded cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedBanks.includes(bank.id)}
                          onChange={(e) => {
                            if (e.target.checked) setSelectedBanks([...selectedBanks, bank.id]);
                            else setSelectedBanks(selectedBanks.filter(id => id !== bank.id));
                          }}
                          className="w-4 h-4"
                        />
                        <span className="text-sm">{bank.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}

          <div className="p-4 bg-slate-50 rounded-lg border space-y-2">
            <label className="flex items-center justify-between cursor-pointer" data-testid="can-edit-bank-toggle">
              <div>
                <span className="text-sm font-medium">Can Edit Bank Details</span>
                <p className="text-xs text-slate-500">Allow this user to edit bank information (profile, cards, KYC, SIM, etc.)</p>
              </div>
              <input type="checkbox" checked={formData.canEditBank} onChange={(e) => setFormData({ ...formData, canEditBank: e.target.checked })} className="w-5 h-5 rounded border-slate-300" />
            </label>
          </div>

          <div className="p-4 bg-slate-50 rounded-lg border space-y-2">
            <label className="flex items-center justify-between cursor-pointer" data-testid="can-upload-toggle">
              <div>
                <span className="text-sm font-medium">Can Upload Excel</span>
                <p className="text-xs text-slate-500">Allow this user to bulk-upload bank details via Excel files</p>
              </div>
              <input type="checkbox" checked={formData.canUpload} onChange={(e) => setFormData({ ...formData, canUpload: e.target.checked })} className="w-5 h-5 rounded border-slate-300" />
            </label>
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit">{editingUser ? 'Update User' : 'Create User'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default UserFormDialog;
